import { render, staticRenderFns } from "./InternalAggregates.vue?vue&type=template&id=b97b1e3e&scoped=true"
import script from "./InternalAggregates.vue?vue&type=script&lang=js"
export * from "./InternalAggregates.vue?vue&type=script&lang=js"
import style0 from "./InternalAggregates.vue?vue&type=style&index=0&id=b97b1e3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97b1e3e",
  null
  
)

export default component.exports